// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"2424": "063ccb7d","4876": "2696f34c","7768": "24dda39f","7869": "22f405b2","9730": "76599b25",}[chunkId] + ".css"
}